require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./research-internships-2-5-1-2.json") })
        }
      }, "path---research-internships-2-5-1-2");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---research-internships-2-5-1-2!./.cache/json/research-internships-2-5-1-2.json
// module id = 548
// module chunks = 231608221292675